// This file is generated by a script and should not be modified directly.
const markdown: string =
  "- peut être `null` lorsque le niveau de diplôme n'a pas de correspondance avec les niveaux européens ou qu'elle n'est pas déterminée.\n- lorsque la fiche RNCP correspondante est connue, il faut priviliégier le niveau européen issue de France Compétences.\n"
export default markdown
